import { Action } from '@ngrx/store';

import {
  ANSRequestModel,
  AutoCoveragesModel,
  CoverageChangeCustomerTemplateDataModel,
  CoverageChangeModel,
  CoverageChangeNotificationRequestCustomerEmail,
  QuoteModel,
  SubmitOnlineBindRequestModel
} from '@amfam/policy/models';
import { ApiStatus } from '@amfam/shared/models';

import { PolicyAnalyticActionPayload } from '../models';
import {
  ChangeCoverageAnalyticsModel,
  CoverageChangeRequest
} from '../models/coverage-change.model';

export enum CoverageChangeActionTypes {
  // Actions to change theCoverage information
  COVERAGE_CHANGE_REQUEST_NOTIFICATION = '[Coverage_Change] Start Notification',
  COVERAGE_CHANGE_SUCCESS_NOTIFICATION = '[Coverage_Change] Success Notification',
  COVERAGE_CHANGE_FAIL_NOTIFICATION = '[Coverage_Change] Fail Notification',

  COVERAGE_CHANGE_REQUEST_EMAIL_NOTIFICATION = '[Coverage_Change] Start Email Notification',
  COVERAGE_CHANGE_SUCCESS_EMAIL_NOTIFICATION = '[Coverage_Change] Success Email Notification',
  COVERAGE_CHANGE_FAIL_EMAIL_NOTIFICATION = '[Coverage_Change] Fail Email Notification',

  COVERAGE_CHANGE_REQUEST_ANS_NOTIFICATION = '[Coverage_Change] Start ANS Notification',
  COVERAGE_CHANGE_SUCCESS_ANS_NOTIFICATION = '[Coverage_Change] Success ANS Notification',
  COVERAGE_CHANGE_FAIL_ANS_NOTIFICATION = '[Coverage_Change] Fail ANS Notification',

  COVERAGE_CHANGE_REQUEST_ANALYTIC_INFORMATION = '[Coverage_Change] Send Analytic Information',

  COVERAGE_CHANGE_COVERAGES_LIMITS_REQUEST = '[Coverage_Change] Coverages Limit Request',
  COVERAGE_CHANGE_COVERAGES_LIMITS_REQUEST_SUCCESS = '[Coverage_Change]  Coverages Limit Request Success',
  COVERAGE_CHANGE_COVERAGES_LIMITS_REQUEST_FAILURE = '[Coverage_Change]  Coverages Limit Request Fail',

  SET_COVERAGE_CHANGE_SELECTED_LIMITS_REQUEST = '[Coverage_Change] Set Coverages Limit',

  COVERAGE_CHANGE_QUOTE_REQUEST = '[Coverage_Change] Quote Request',
  COVERAGE_CHANGE_QUOTE_REQUEST_SUCCESS = '[Coverage_Change] Quote Request Success',
  COVERAGE_CHANGE_QUOTE_REQUEST_FAILURE = '[Coverage_Change] Quote Request Failure',

  COVERAGE_CHANGE_ONLINE_BIND_REQUEST = '[Coverage_Change] Online Bind',
  COVERAGE_CHANGE_ONLINE_BIND_REQUEST_SUCCESS = '[Coverage_Change] Online Bind Success',
  COVERAGE_CHANGE_ONLINE_BIND_REQUEST_FAIL = '[Coverage_Change] Online Bind Fail',

  COVERAGE_CHANGE_REQUEST_RESET_STATE = '[Coverage_Change] Reset State',
  COVERAGE_CHANGE_REQUEST_SET_CANCEL_PATH = '[Coverage_Change] Set Cancel Path',

  SEND_COVERAGE_ANALYTICS = '[Coverage_Change] Send Analytics',
  COVERAGE_CHANGE_SET_REQUEST_TYPE = '[Coverage_Change] Set Request Type'
}

export class CoverageChangeRequestNotificationAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_REQUEST_NOTIFICATION;
  constructor(public payload: CoverageChangeCustomerTemplateDataModel) {}
}

export class CoverageChangeRequestNotificationSuccessAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_SUCCESS_NOTIFICATION;
  constructor(public payload: CoverageChangeCustomerTemplateDataModel) {}
}

export class CoverageChangeRequestNotificationFailAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_FAIL_NOTIFICATION;
  constructor(public payload: ApiStatus) {}
}

export class CoverageChangeOnlineBindRequestAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_ONLINE_BIND_REQUEST;
  constructor(public payload: SubmitOnlineBindRequestModel) {}
}

export class CoverageChangeOnlineBindRequestSuccessAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_ONLINE_BIND_REQUEST_SUCCESS;
  constructor(public payload: SubmitOnlineBindRequestModel) {}
}

export class CoverageChangeOnlineBindRequestFailAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_ONLINE_BIND_REQUEST_FAIL;
  constructor(public payload: ApiStatus) {}
}

export class CoverageChangeCoveragesLimitsRequestAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_COVERAGES_LIMITS_REQUEST;
  constructor() {}
}

export class CoverageChangeCoveragesLimitsRequestSuccessAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_COVERAGES_LIMITS_REQUEST_SUCCESS;
  constructor(public payload: AutoCoveragesModel) {}
}

export class CoverageChangeCoveragesLimitsRequestFailAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_COVERAGES_LIMITS_REQUEST_FAILURE;
  constructor(public payload: ApiStatus) {}
}

export class CoverageChangesGetQuoteRequestAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_QUOTE_REQUEST;
  constructor(public payload: CoverageChangeModel) {}
}

export class CoverageChangeGetQuoteRequestSuccessAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_QUOTE_REQUEST_SUCCESS;
  constructor(public payload: QuoteModel) {}
}

export class CoverageChangeGetQuoteRequestFailAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_QUOTE_REQUEST_FAILURE;
  constructor(public payload: ApiStatus) {}
}

export class CoverageChangeSetSelectedLimitsRequestAction implements Action {
  readonly type = CoverageChangeActionTypes.SET_COVERAGE_CHANGE_SELECTED_LIMITS_REQUEST;
  constructor(public payload: CoverageChangeModel) {}
}

export class CoverageChangeRequestCustomerEmailNotificationAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_REQUEST_EMAIL_NOTIFICATION;
  constructor(public payload: CoverageChangeNotificationRequestCustomerEmail) {}
}

export class CoverageChangeRequestCustomerSuccessEmailNotificationAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_SUCCESS_EMAIL_NOTIFICATION;
  constructor(public payload: CoverageChangeRequest) {}
}

export class CoverageChangeRequestCustomerFailEmailNotificationAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_FAIL_EMAIL_NOTIFICATION;
  constructor(public payload: ApiStatus) {}
}

export class CoverageChangeRequestResetStateAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_REQUEST_RESET_STATE;
  constructor(public payload?: ApiStatus) {}
}

export class CoverageChangeRequestANSNotificationAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_REQUEST_ANS_NOTIFICATION;
  constructor(public payload: ANSRequestModel) {}
}

export class CoverageChangeRequestSuccessANSNotificationAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_SUCCESS_ANS_NOTIFICATION;
  constructor(public payload: ANSRequestModel) {}
}

export class CoverageChangeRequestFailANSNotificationAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_FAIL_ANS_NOTIFICATION;
  constructor(public payload: {}) {}
}

export class CoverageChangeRequestSendAnalyticAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_REQUEST_ANALYTIC_INFORMATION;
  constructor(public payload: PolicyAnalyticActionPayload) {}
}

export class CoverageChangeRequestSetCancelPathAction implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_REQUEST_SET_CANCEL_PATH;
  constructor(public payload: string) {}
}

export class SendCoverageAnalyticsAction implements Action {
  readonly type = CoverageChangeActionTypes.SEND_COVERAGE_ANALYTICS;
  constructor(public payload: ChangeCoverageAnalyticsModel) {}
}

export class CoverageChangeSetRequestType implements Action {
  readonly type = CoverageChangeActionTypes.COVERAGE_CHANGE_SET_REQUEST_TYPE;
  constructor(public payload: 'OnlineBind' | 'SendToAgent') {}
}

export type CoverageChangeActionsUnion =
  | CoverageChangeRequestNotificationAction
  | CoverageChangeRequestNotificationSuccessAction
  | CoverageChangeRequestNotificationFailAction
  | CoverageChangeRequestCustomerEmailNotificationAction
  | CoverageChangeRequestCustomerSuccessEmailNotificationAction
  | CoverageChangeRequestCustomerFailEmailNotificationAction
  | CoverageChangeRequestANSNotificationAction
  | CoverageChangeRequestSuccessANSNotificationAction
  | CoverageChangeRequestFailANSNotificationAction
  | CoverageChangeRequestResetStateAction
  | CoverageChangeRequestSendAnalyticAction
  | CoverageChangeRequestSetCancelPathAction
  | CoverageChangeCoveragesLimitsRequestAction
  | CoverageChangeCoveragesLimitsRequestSuccessAction
  | CoverageChangeSetSelectedLimitsRequestAction
  | CoverageChangesGetQuoteRequestAction
  | CoverageChangeGetQuoteRequestSuccessAction
  | CoverageChangeGetQuoteRequestFailAction
  | CoverageChangeCoveragesLimitsRequestFailAction
  | CoverageChangeOnlineBindRequestAction
  | CoverageChangeOnlineBindRequestSuccessAction
  | CoverageChangeOnlineBindRequestFailAction
  | SendCoverageAnalyticsAction
  | CoverageChangeSetRequestType;
